const { getAxiosInstance } = require('../connection');

module.exports = {
    toggleFavorite: function (itemId, isFavorite = true) {
        return getAxiosInstance({
            url: `/favorite_sponsors${isFavorite ? '' : `/${itemId}`}`,
            method: isFavorite ? 'post' : 'delete',
            json: true,
            data: {
                sponsor_id: itemId,
            },
        }).then((r) => r.data);
    },
};
